import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import "./Login.css";
import axios from 'axios';
import LoaderButton from "../components/LoaderButton";
import ReactGA from 'react-ga';
import config from "../config";

const base64 = require('base-64');

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.initializeReactGA();

    this.state = {
      isLoading: false,
      isLoadingPass: false,
      failedAuth: false,
      email: "",
      password: "",
      forgotPasswordMessage: ""
    };
  }

  initializeReactGA() {
    ReactGA.initialize('UA-136595020-1');
    ReactGA.pageview('/Login');
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  validateForgotPassword() {
    return this.state.email.length > 0 ;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleForgotPassword = event => {
    event.preventDefault();

    // Put up loading symbol
    this.setState({ isLoadingPass: true });


      axios.post(config.API_HOST + '/user/forgotPassword',
                 { email: this.state.email })
      .then(res => {
        console.log(res);

        this.setState({ isLoadingPass: false });
        this.setState({ forgotPasswordMessage: "Ok we emailed you, your password"})

      })
      .catch (e =>
      {console.log('error ' + e.message);
        // take down loading symbol
        this.setState({ isLoadingPass: false });
       this.setState({ forgotPasswordMessage: "There was an issue sending you your password. Please try again."})
      });
  }

   handleSubmit = event => {
    event.preventDefault();

    // Put up loading symbol
    this.setState({ isLoading: true });


      axios.post(config.API_HOST + '/user/auth',
                 { email: this.state.email,
                   password: this.state.password})
      .then(res => {
        console.log(res);
        // Put response data in the console for now during dev
        console.log(res.data.user_id);
        console.log(base64.encode(this.state.email,":",this.state.password));

        // Store the auth info in state and local browser cache
        this.props.userHasAuthenticated(true);
        this.props.setUserAuth(base64.encode(this.state.email + ":" + this.state.password));
        this.props.setUserId(res.data.user_id);

        // send the user to home screen on login
        this.props.history.push("/");
      })
      .catch (e =>
      {console.log('error ' + e.message);
        // take down loading symbol
        this.setState({ isLoading: false });
        this.setState({ failedAuth: true });
      });
  }

  render() {
    return (
      <div className="Login">
        <form onSubmit={this.handleSubmit}>

          {this.state.failedAuth
            ? <h4> The username or password is incorrect </h4>
            : <p></p>
          }

          <h4> {this.state.forgotPasswordMessage} </h4>

          <FormGroup controlId="email" bsSize="large">
            <ControlLabel>Email</ControlLabel>
            <FormControl
              autoFocus
              type="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>

          <FormGroup controlId="password" bsSize="large">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>

          <LoaderButton
            block
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Login"
            loadingText="Logging in…"
          />

          <LoaderButton
            block
            bsSize="large"
            disabled={!this.validateForgotPassword()}
            type="submit"
            isLoading={this.state.isLoadingPass}
            onClick={this.handleForgotPassword}
            text="Forgot Password"
            loadingText="Emailing your password..."
            />

        </form>

      </div>
    );
  }
}
